import { Component, Watch } from 'vue-property-decorator';

import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import SM2Base from '../SM2Base';

import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'

import StrukturGrafik from '../StrukturGrafik/StrukturGrafik'
import StrukturTabelle from '../StrukturTabelle/StrukturTabelle'
import SmartButton from 'tivigi/src/components/SmartButton/SmartButton'
import WithRender from './StrukturelleSituation.html';

@WithRender
@Component({
    components: {FloatingWindow,  Superbutton, StrukturGrafik, StrukturTabelle, SmartButton }
})
export default class StrukturelleSituation extends SM2Base {

    spatialUnit: any = null;

    mode = 'tabelle'


    get compareUnits(): Array<any> {
        let result = Array<any>()

        result.push(this.spatialUnit)
        result.push(this.getSpatialUnit("Z0040"))
        result.push(this.getSpatialUnit("Z0050"))
        

        return result
    }

    indicatorsList = ["r0001", "r0003", "r0005", "r0008", "r0010", "r0011", "r0014", "r0018", "r0021", "r0025",
        "r0030", "r0032", "r0033", "r0039", "r0040", "r0042", "r0044", "r0046", "r0047", "r0051", "r0052", "r0055", "r0058", "r0059", "r0060"]
}


